import { useState, useCallback } from 'react';
import { Helmet } from 'react-helmet-async';
import { Container, Stack, Typography, Grid, Paper } from '@mui/material';
import ESPWebTools from '../components/ESPWebTools';
import FirmwareVersionPicker from '../components/FirmwareVersionPicker';
import { API_ENDPOINT } from '../services/common';

const DEFAULT_MODEL = 'PTQS1005';

export default function SensorPage() {
  const [manifestPath, setManifestPath] = useState(
    `${API_ENDPOINT}/firmware/manifest?model=${DEFAULT_MODEL}`
  );

  const handleVersionSelect = useCallback((version) => {
    setManifestPath(`${API_ENDPOINT}/firmware/manifest?model=${DEFAULT_MODEL}&version=${version}`);
  }, []);

  return (
    <>
      <Helmet>
        <title> VPSI | Sensor </title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Sensor Installation
          </Typography>
        </Stack>

        <Typography variant="h6" gutterBottom>
          Available Firmware Versions:
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom mb={4}>
          If you see &quot;Failed to initialize&quot; or &quot;Couldn&apos;t sync&quot;, press Back
          and click Install again. If it still fails, refresh the page, power-cycle the sensor, and
          try again.
        </Typography>

        <Grid container spacing={3} justifyContent={'center'}>
          <Grid item xs={12} md={6}>
            <FirmwareVersionPicker model={DEFAULT_MODEL} onVersionSelect={handleVersionSelect} />
            <ESPWebTools
              title="VPSI Air Quality Sensor"
              description="Reads CO2, TVOC, Formaldehyde, and Particulate Matter and sends them to your device."
              manifestPath={manifestPath}
              imagePath="/assets/images/sensors/NewSensor.png"
            />
          </Grid>
        </Grid>

        <Paper elevation={2} sx={{ p: 3, mt: 3 }}>
          <Typography variant="h6" gutterBottom>
            Before connecting:
          </Typography>
          <Typography variant="body2" color="text.secondary">
            <ul>
              <li>Close any applications using the serial port (Arduino IDE, Serial Monitor, etc.)</li>
              <li>Try disconnecting and reconnecting your device</li>
              <li>If using Windows, ensure you have the correct USB drivers installed</li>
              <li>
                If you do need the drivers, you can find them{' '}
                <a
                  href="https://learn.sparkfun.com/tutorials/how-to-install-ch340-drivers#drivers-if-you-need-them"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  here
                </a>
              </li>
            </ul>
          </Typography>
        </Paper>
      </Container>
    </>
  );
}
